import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from "vuex";
import DoughnutShadowChart from "../../../components/Charts/DoughnutShadow";
import Draggable from "vuedraggable";
import QuestionBuilder from "../../../components/SurveyApp/QuestionBuilder";
import ApplicationMenu from "../../../components/Common/ApplicationMenu";
import { ThemeColors } from "../../../utils";
var colors = ThemeColors();
export default {
  components: {
    draggable: Draggable,
    "question-builder": QuestionBuilder,
    "application-menu": ApplicationMenu,
    "doughnut-shadow-chart": DoughnutShadowChart
  },
  data: function data() {
    return {
      categories: [{
        label: "Development",
        value: "Development"
      }, {
        label: "Workplace",
        value: "Workplace"
      }, {
        label: "Hardware",
        value: "Hardware"
      }],
      labels: [{
        label: "EDUCATION",
        value: "EDUCATION",
        color: "secondary"
      }, {
        label: "NEW FRAMEWORK",
        value: "NEW FRAMEWORK",
        color: "primary"
      }, {
        label: "PERSONAL",
        value: "PERSONAL",
        color: "info"
      }],
      statuses: [{
        text: "ACTIVE",
        value: "ACTIVE"
      }, {
        text: "COMPLETED",
        value: "COMPLETED"
      }],
      currentSurvey: null,
      tabIndex: 0,
      ageChartData: {
        labels: ["12-24", "24-30", "30-40", "40-50", "50-60"],
        datasets: [{
          label: "",
          borderColor: [colors.themeColor1, colors.themeColor2, colors.themeColor3, colors.themeColor4, colors.themeColor5],
          backgroundColor: [colors.themeColor1_10, colors.themeColor2_10, colors.themeColor3_10, colors.themeColor4_10, colors.themeColor5_10],
          borderWidth: 2,
          data: [15, 25, 20, 30, 14]
        }]
      },
      genderChartData: {
        labels: ["Male", "Female", "Other"],
        datasets: [{
          label: "",
          borderColor: [colors.themeColor1, colors.themeColor2, colors.themeColor3],
          backgroundColor: [colors.themeColor1_10, colors.themeColor2_10, colors.themeColor3_10],
          borderWidth: 2,
          data: [85, 45, 20]
        }]
      },
      workChartData: {
        labels: ["Employed for wages", "Self-employed", "Looking for work", "Retired"],
        datasets: [{
          label: "",
          borderColor: [colors.themeColor1, colors.themeColor2, colors.themeColor3, colors.themeColor4],
          backgroundColor: [colors.themeColor1_10, colors.themeColor2_10, colors.themeColor3_10, colors.themeColor4_10],
          borderWidth: 2,
          data: [15, 25, 20, 8]
        }]
      },
      codingChartData: {
        labels: ["Python", "JavaScript", "PHP", "Java", "C#"],
        datasets: [{
          label: "",
          borderColor: [colors.themeColor1, colors.themeColor2, colors.themeColor3, colors.themeColor4, colors.themeColor5],
          backgroundColor: [colors.themeColor1_10, colors.themeColor2_10, colors.themeColor3_10, colors.themeColor4_10, colors.themeColor4_10],
          borderWidth: 2,
          data: [15, 25, 20, 8, 25]
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters(["isLoadSurveys", "surveyItems", "surveyError"])),
  methods: _objectSpread({}, mapActions(["getSurveyItems"]), {}, mapMutations(["addSurveyItem"]), {
    addQuestion: function addQuestion() {
      this.currentSurvey.questions.push({
        id: this.currentSurvey.questions.length + 1,
        title: "New Question",
        question: "Question",
        answerType: 0,
        answers: []
      });
    }
  }),
  mounted: function mounted() {
    this.getSurveyItems();
    document.body.classList.add("right-menu");
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove("right-menu");
  },
  watch: {
    isLoadSurveys: function isLoadSurveys(val) {
      if (val === true) {
        this.currentSurvey = this.surveyItems[0];
      }
    }
  }
};